export const loading = state => state.common.loading;
export const message = state => state.common.message;
export const environment = state => state.common.environment;
export const instanceId = state => state.common.instanceId;

export const userName = state => state.common.userInfo.userName;
export const isAuthorized = state => state.common.isAuthorized;
export const userRights = state => state.common.userRights;
export const roles = state => state.common.roles;
